import CartContainer from 'modules/CartCheckOut/containers/CartContainer';

type Props = {}

const Cart = (props: Props) => {
    return (
        <CartContainer />
    )
}

export default Cart;